export const Award = () => {
  const achievements = [
    {
      id: 1,
      logo: "https://thames-demo-nuxt.vercel.app/images/award/dark/award-logo1.png",
      title: "Top Full-Stack Developer",
      year: "2024",
      organization: "Tech Excellence Forum",
      location: "Cairo, Egypt",
      description: "Recognized for developing high-performance web applications using Node.js, React, and MongoDB."
    },
    // {
    //   id: 2,
    //   logo: "https://thames-demo-nuxt.vercel.app/images/award/dark/award-logo2.png",
    //   title: "Cybersecurity Specialist Award",
    //   year: "2023",
    //   organization: "Global Security Summit",
    //   location: "Remote",
    //   description: "Awarded for exceptional work in identifying web vulnerabilities and securing enterprise-level Java applications."
    // },
  ];

  return (
    <section id="awards" className="container-md my-5">
      <div className="text-center mb-5">
        <span style={{ color: "#00ff00", textTransform: "uppercase", letterSpacing: "2px" }}>Success Stories</span>
        <h1 className="text-white mb-3" style={{ fontSize: 50, fontWeight: 600 }}>
          Awards &amp; Achievements
        </h1>
      </div>
      <div>
        {achievements.map((item) => (
          <div
            key={item.id}
            className="awardDiv d-flex justify-content-between flex-wrap align-items-center text-white p-3"
            style={{
              borderTop: "1px solid #474747",
              borderBottom: "1px solid #474747"
            }}
          >
            <div className="m-3">
              <img
                src={item.logo}
                className="img-fluid"
                alt="Award Logo"
              />
            </div>
            <div className="m-3">
              <strong>{item.title}</strong> 
              <p className="mb-0 text-secondary">{item.year}</p>
            </div>
            <div className="m-3">
              <strong>{item.organization}</strong> 
              <p className="mb-0 text-secondary">{item.location}</p>
            </div>
            <div className="m-3">
              <p className="mb-0" style={{ maxWidth: "400px" }}>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};